import { getCurrentLanguage } from "./language-resolver";

/** Locales Intl par langue de l'app (fr/en/zh). */
const INTL_LOCALES: Record<string, string> = {
  fr: "fr-FR",
  en: "en-US",
  zh: "zh-CN",
};

/** Devise par défaut de Flash Pay (Guinée). */
const DEFAULT_CURRENCY = "GNF";

export const globalFormatAmount = (
  amount: string | number | null | undefined,
  currency: string = DEFAULT_CURRENCY
) => {
  if (amount == null || amount === "") return "—";
  const numAmount = typeof amount === "string" ? parseFloat(amount) : amount;
  if (Number.isNaN(numAmount)) return "—";
  const safeCurrency =
    typeof currency === "string" && /^[A-Z]{3}$/i.test(currency.trim())
      ? currency.trim().toUpperCase()
      : DEFAULT_CURRENCY;
  const locale = INTL_LOCALES[getCurrentLanguage()] ?? "fr-FR";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: safeCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(numAmount);
  } catch {
    return `${numAmount.toLocaleString(locale)} ${safeCurrency}`;
  }
};
